import React from 'react';
import { VideoType } from '../../../commonTypes/video';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { StyledSquareVideo } from './styles';

export type VideoProps = VideoType & ComponentProps;

const SquareVideo: React.FC<VideoProps> = ({
  src,
  screenReaderText,
  videoCookiePolicyData,
  ...props
}) => {
  return (
    <StyledSquareVideo
      {...componentProps(props)}
      src={src}
      screenReaderText={screenReaderText}
      videoCookiePolicyData={videoCookiePolicyData}
    />
  );
};

export default applyComponentTheme(SquareVideo, 'SquareVideo');
